import styled from 'styled-components'

export const StyledWhatsNewContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  max-width: 360px;

  .whatsNew-steps {
    font-size: 13px;
    font-weight: 400;
    color: #666;
    margin-bottom: 4px;
  }

  .whatsNew-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 4px;
    color: #333;
  }

  .whatsNew-body {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    margin-bottom: 12px;
    color: #000;
  }

  .whatsNew-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .whatsNew-close {
    padding: 4px 12px;
    border-radius: 8px;
    border: 1px solid #2758b9;
    color: #2758b9;
    background: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
  }

  .whatsNew-next {
    padding: 4px 12px;
    border-radius: 8px;
    border: none;
    background: #2758b9;
    color: #fff;
    cursor: pointer;
    font-size: 13px;
  }
`
